import { TFunction } from "react-i18next";
import { Item } from "../../../../../../utils/types/generals";

const timeOut = ({ t }: { t: TFunction<'translation', undefined> }): Item[] => ([
    {
        label: t('companie.time', { time: 12 }),
        value: 12,
        id: '1'
    },
    {
        label: t('companie.time', { time: 24 }),
        value: 24,
        id: '2'
    },
    {
        label: t('companie.time', { time: 36 }),
        value: 36,
        id: '3'
    },
    {
        label: t('companie.time', { time: 48 }),
        value: 48,
        id: '4'
    },
])

export { timeOut }
